// @flow
import type { UserAccess } from '../../../lib/types';
import { accessTypeEnum } from '../../../lib/enum';

export const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.adminBranch,
  accessTypeEnum.handlingBudgetAnalysis
];

export const canAdd = (userAccess: UserAccess[]) =>
  userAccess.some(access => addAccessRight.includes(access));

export default {
  addAccessRight,
  canAdd
};
